import { HttpResponse } from 'msw'
import type { components } from 'src/lib/api-client/schema.gen'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

type GetFeatureFlagsApiRes = components['schemas']['output.GetFeatureFlags']

export const getFeatureFlagsHandler = restHandlerFactory(
  '/trials/{trial_uid}/feature-flags',
  'get',
  () => HttpResponse.json(getFeatureFlagsApiResMock, { status: 200 }),
)

const getFeatureFlagsApiResMock: GetFeatureFlagsApiRes = {
  featureFlags: {
    eRecruit: true,
  },
}
